import React from 'react';
import './DiscoverFilters.css';

const cefrLevels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'Not sure'];

const DiscoverFilters = ({
  languageFilter,
  setLanguageFilter,
  languageOptions,
  nativeLanguageFilter,
  setNativeLanguageFilter,
  nativeLanguageOptions,
  levelFilter,
  setLevelFilter,
  levelOptions,
  usersSort,
  setUsersSort,
  search,
  setSearch,
  handleFindMatches,
  activeTab,

  groupSearch,
  setGroupSearch,
  groupLanguage,
  setGroupLanguage,
  groupLevel,
  setGroupLevel,
  groupDayOfWeek,
  setGroupDayOfWeek,
  groupTimeFrom,
  setGroupTimeFrom,
  groupTimeTo,
  setGroupTimeTo,
  groupLanguageOptions,
  groupDayOptions,
  groupsSort,
  setGroupsSort,

  eventSearch,
  setEventSearch,
  eventLanguage,
  setEventLanguage,
  eventDateFrom,
  setEventDateFrom,
  eventDateTo,
  setEventDateTo,
  eventLanguageOptions,
  eventUpcomingOnly,
  setEventUpcomingOnly,
  eventAttendingOnly,
  setEventAttendingOnly,
  eventsSort,
  setEventsSort,
  includeConnectedUsers,
  setIncludeConnectedUsers
}) => (
  <div className="filter-container">
    {activeTab === 'users' && (
      <div className="users-filters-grid">
        <div className="users-filter-item">
          <label className="filter-label">Partner learning</label>
          <select
            className="filter-select"
            value={languageFilter}
            onChange={e => setLanguageFilter(e.target.value)}
          >
            <option value="">Any language</option>
            {languageOptions.map(lang => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>

        <div className="users-filter-item">
          <label className="filter-label">Partner native in</label>
          <select
            className="filter-select"
            value={nativeLanguageFilter}
            onChange={e => setNativeLanguageFilter(e.target.value)}
          >
            <option value="">Any language</option>
            {nativeLanguageOptions.map(lang => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>

        <div className="users-filter-item">
          <label className="filter-label">Level</label>
          <select
            className="filter-select"
            value={levelFilter}
            onChange={e => setLevelFilter(e.target.value)}
          >
            <option value="">All Levels</option>
            {cefrLevels.map((lvl) => (
              <option key={lvl} value={lvl}>{lvl}</option>
            ))}
          </select>
        </div>

        <div className="users-filter-item">
          <label className="filter-label">Sort</label>
          <select
            className="filter-select"
            value={usersSort || 'best_match'}
            onChange={(e) => setUsersSort && setUsersSort(e.target.value)}
          >
            <option value="best_match">Best match</option>
            <option value="most_active">Most active</option>
            <option value="newest">Newest</option>
          </select>
        </div>

        <div className="users-filter-item users-filter-item--search">
          <label className="filter-label">Name search</label>
          <input
            className="search-input"
            type="text"
            placeholder="Search by name..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div className="users-filter-item users-filter-item--toggle">
          <label className="filter-label">{'\u00A0'}</label>
          <label className="users-toggle">
            <input
              type="checkbox"
              checked={!!includeConnectedUsers}
              onChange={(e) => setIncludeConnectedUsers(e.target.checked)}
            />
            Include connected
          </label>
        </div>

        <div className="users-filter-item users-filter-item--cta">
          <button className="find-matches-btn" onClick={handleFindMatches}>
            Find Language Matches
          </button>
        </div>
      </div>
    )}

    {activeTab === 'groups' && (
      <div className="groups-filters-grid">
        <div className="groups-filter-item">
          <label className="filter-label">Language</label>
          <select
            className="filter-select"
            value={groupLanguage}
            onChange={e => setGroupLanguage(e.target.value)}
          >
            <option value="">Any</option>
            {(groupLanguageOptions || []).map((lang) => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>

        <div className="groups-filter-item">
          <label className="filter-label">Level</label>
          <select
            className="filter-select"
            value={groupLevel}
            onChange={e => setGroupLevel(e.target.value)}
          >
            <option value="">All Levels</option>
            {cefrLevels.map((lvl) => (
              <option key={lvl} value={lvl}>{lvl}</option>
            ))}
          </select>
        </div>

        <div className="groups-filter-item">
          <label className="filter-label">Day</label>
          <select
            className="filter-select"
            value={groupDayOfWeek}
            onChange={e => setGroupDayOfWeek(e.target.value)}
          >
            <option value="">Any</option>
            {(groupDayOptions || []).map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
        </div>

        <div className="groups-filter-item groups-filter-item--time">
          <label className="filter-label">From</label>
          <input
            className="search-input"
            type="time"
            value={groupTimeFrom}
            onChange={(e) => setGroupTimeFrom(e.target.value)}
          />
        </div>

        <div className="groups-filter-item groups-filter-item--time">
          <label className="filter-label">To</label>
          <input
            className="search-input"
            type="time"
            value={groupTimeTo}
            onChange={(e) => setGroupTimeTo(e.target.value)}
          />
        </div>

        <div className="groups-filter-item">
          <label className="filter-label">Sort</label>
          <select
            className="filter-select"
            value={groupsSort || 'best_match'}
            onChange={(e) => setGroupsSort && setGroupsSort(e.target.value)}
          >
            <option value="best_match">Best match</option>
            <option value="newest">Newest</option>
          </select>
        </div>

        <div className="groups-filter-item groups-filter-item--search">
          <label className="filter-label">Search</label>
          <input
            className="search-input"
            type="text"
            placeholder="Search groups..."
            value={groupSearch}
            onChange={e => setGroupSearch(e.target.value)}
          />
        </div>
      </div>
    )}

    {activeTab === 'events' && (
      <div className="events-filters-grid">
        <div className="events-filter-item">
          <label className="filter-label">Language</label>
          <select
            className="filter-select"
            value={eventLanguage}
            onChange={e => setEventLanguage(e.target.value)}
          >
            <option value="">Any</option>
            {(eventLanguageOptions || []).map((lang) => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>

        <div className="events-filter-item">
          <label className="filter-label">From date</label>
          <input
            className="search-input"
            type="date"
            value={eventDateFrom}
            onChange={e => setEventDateFrom(e.target.value)}
          />
        </div>

        <div className="events-filter-item">
          <label className="filter-label">To date</label>
          <input
            className="search-input"
            type="date"
            value={eventDateTo}
            onChange={e => setEventDateTo(e.target.value)}
          />
        </div>

        <div className="events-filter-item">
          <label className="filter-label">Sort</label>
          <select
            className="filter-select"
            value={eventsSort || 'soonest'}
            onChange={(e) => setEventsSort && setEventsSort(e.target.value)}
          >
            <option value="soonest">Soonest</option>
            <option value="best_match">Best match</option>
          </select>
        </div>

        <div className="events-filter-item events-filter-item--search">
          <label className="filter-label">Search</label>
          <input
            className="search-input"
            type="text"
            placeholder="Search events..."
            value={eventSearch}
            onChange={e => setEventSearch(e.target.value)}
          />
        </div>

        <div className="events-filter-item events-filter-item--toggles">
          <label className="filter-label">{'\u00A0'}</label>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <label className="events-toggle">
              <input
                type="checkbox"
                checked={!!eventUpcomingOnly}
                onChange={(e) => setEventUpcomingOnly(e.target.checked)}
              />
              Upcoming only
            </label>
            <label className="events-toggle">
              <input
                type="checkbox"
                checked={!!eventAttendingOnly}
                onChange={(e) => setEventAttendingOnly(e.target.checked)}
              />
              Attending only
            </label>
          </div>
        </div>
      </div>
    )}

    {activeTab === 'users' && null}
  </div>
);

export default DiscoverFilters;